import { render, staticRenderFns } from "./labelCell.vue?vue&type=template&id=12d9f2a8"
import script from "./labelCell.vue?vue&type=script&lang=js"
export * from "./labelCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports